import { IGetMotivosDemissaoDropDownUseCase } from "../../../presentation/useCases/read/get_motivos_demissao_dropdown_use_case";
import { MotivoDemissaoDropDown } from "../../models/motivo_demissao_dropdown";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetMotivosDemissaoDropDownUseCase
 */

export class GetMotivosDemissaoDropDownUseCase implements IGetMotivosDemissaoDropDownUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async getMotivosDemissaoDropDown(): Promise<MotivoDemissaoDropDown[]> {
    const response = await this.repository.getMotivosDemissaoDropDown();
    return [...response];
  }
}